import React from "react";

import ProductPage from "../../../components/ProductPage";

import hero from "../../../img/optometrie-sortiment.jpg";
import experienceIcon from "../../../img/experience.svg";
import stopwatchIcon from "../../../img/stopwatch.svg";
import insigniaIcon from "../../../img/insignia.svg";
import reviewImage from "../../../img/person-for-products.jpg";

const Optometrie = () => (
  <ProductPage
    title="Optometrie"
    centeredHeading
    description="Optometrické služby, které Optika Volyně poskytuje"
    keywords="Optika, Optometrie, Volyně, Zrak, Oči"
    hero={hero}
    heroAlt="foto vybavení pro měření zraku"
    boxes={[
      {
        icon: experienceIcon,
        iconAlt: "ikona odbornost",
        heading: "Odbornost",
        text: "Optometrické vyšetření provádí vždy vysoce kvalifikovaný pracovník. Věnujeme vám vždy plnou pozornost, poradíme a pomocí moderních optometrických nástrojů a metod se postaráme o vaše oči.",
      },
      {
        icon: stopwatchIcon,
        iconAlt: "ikona rychlosti",
        heading: "Rychlost",
        text: "Zrak si k nám můžete nechat zajít vyšetřit kdykoliv během naší otevírací doby a to i bez objednání. Věnovat se vám budeme hned, jakmile to bude možné a klidně během pár minut může být hotovo.",
      },
      {
        icon: insigniaIcon,
        iconAlt: "ikona vyhody",
        heading: "Výhody",
        text: "Veškeré optometrické služby, které vám uděláme, máte při následném nákupu jakýchkoliv brýlí zdarma. S výběrem vám na základě vyšetření samozřejmě pomůžeme a společně se pokusíme najít to nejlepší možné řešení.",
      },
    ]}
    review={{
      text: "Do optiky jsem přišel těsně před zavíračkou a přesto mi vlídně provedli vyšetření zraku, seznámili mě s jeho výsledky a poradili mi s výběrem brýlí. Díky rozsáhlé nabídce mi hned jedny padly do oka a během půl hodiny jsem tak odcházel s novými brýlemi a vyšetřením zdarma.",
      image: reviewImage,
      imageAlt: "referent Matěj",
      name: "Matěj",
    }}
  />
);

export default Optometrie;
